import React, { useContext } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { VehicleContext } from "../Context/VehicleContext";
import ReCAPTCHA from "react-google-recaptcha";

const contactMethods = ["Phone", "Email", "Text"];

const validationSchema = Yup.object({
  location: Yup.string().required("Location is required"),
  first_name: Yup.string().required("First name is required"),
  last_name: Yup.string().required("Last name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  phone: Yup.string().required("Phone number is required"),
  comments: Yup.string(),
  contactmethod: Yup.array().min(1, "Select at least one method"),
});

const ContactForm = () => {
  const { submitContactForm } = useContext(VehicleContext);
  const recaptchaRef = React.useRef();

  return (
    <Formik
      initialValues={{
        location: "TAMPA, FL",
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        comments: "",
        contactmethod: [],
      }}
      validationSchema={validationSchema}
      onSubmit={async (values, { resetForm }) => {
        const token = await recaptchaRef.current.executeAsync();
        recaptchaRef.current.reset(); // Reset after use

        values.token = token;

        console.log(values);
        const data = await submitContactForm(values);
        if (data.success) {
          resetForm();
          alert("Thank you for your submission. We'll be in touch soon!");
        } else
          alert("There was a problem with your submission");
      }}
    >
      {({ values }) => (
        <Form>
          <ReCAPTCHA
              ref={recaptchaRef}
              sitekey="6LckXRIsAAAAAAiOe2UBkXy7Uy-ROdiueqrr4Lzk" // Replace with your actual site key
              size="invisible"
          /> 
          <div className="row  wow reveal fadeInUp">
            {/* Location */}
            <div className="col-12 mb-4">
              <div className="xs-title fw-700 text-uppercase font-14 mb-3">
                Select Location
              </div>
              <div className="location-options d-flex">
                <label className="custom-radio me-md-5 me-4">
                  <Field type="radio" name="location" value="TAMPA, FL" />
                  <span className="radio-mark"></span> Tampa, FL
                </label>
                <label className="custom-radio">
                  <Field type="radio" name="location" value="SAN CLEMENTE, CA" />
                  <span className="radio-mark"></span> San Clemente, CA
                </label>
              </div>
              <ErrorMessage
                name="location"
                component="div"
                className="text-danger small"
              />
            </div>

            {/* Left column */}
            <div className="col-md-6">
              <div className="form-group">
                <div className="cs-label mb-2">First Name</div>
                <Field type="text" name="first_name" className="form-control" />
                <ErrorMessage
                  name="first_name"
                  component="div"
                  className="text-danger small"
                />
              </div>

              <div className="form-group">
                <div className="cs-label mb-2">Last Name</div>
                <Field type="text" name="last_name" className="form-control" />
                <ErrorMessage
                  name="last_name"
                  component="div"
                  className="text-danger small"
                />
              </div>

              <div className="form-group">
                <div className="cs-label mb-2">Email</div>
                <Field type="text" name="email" className="form-control" />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="text-danger small"
                />
              </div>

              <div className="form-group">
                <div className="cs-label mb-2">Phone</div>
                <Field type="text" name="phone" className="form-control" />
                <ErrorMessage
                  name="phone"
                  component="div"
                  className="text-danger small"
                />
              </div>
            </div>

            {/* Right column */}
            <div className="col-md-6">
              <div className="form-group mb-5">
                <div className="cs-label mb-2">Comments</div>
                <Field
                  as="textarea"
                  name="comments"
                  className="form-control h-180"
                />
              </div>

              <div className="xs-title fw-700 text-uppercase font-14 mb-3">
                How would you like for us to contact you?
              </div>
              <div className="d-md-flex align-items-center ps-md-0 ps-4">
                {contactMethods.map((method) => (
                  <div
                    className="custom-checkbox location-checkbox contact-method-checkbox me-md-5 mb-md-0 mb-3 pe-3"
                    key={method}
                  >
                    <Field
                      type="checkbox"
                      name="contactmethod"
                      value={method}
                      id={`method${method}`}
                    />
                    <label htmlFor={`method${method}`} className="w-100">
                      {method}
                    </label>
                  </div>
                ))}
              </div>
              <ErrorMessage
                name="contactmethod"
                component="div"
                className="text-danger small"
              />
            </div>
            <div className="col-12 mt-md-5 mt-4">
              <div className="text-end">
                <button
                  type="submit"
                  className="orange-white-btn font-1-2em fw-700 lg-btn text-uppercase d-inline-block w-240"
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default ContactForm;
